import { action, observable, runInAction } from 'mobx';
// import sortBy from 'lodash/sortBy';

import { communicationController } from './communicationController';
import {
  OrderCommunicationInterface,
  CreateOrderCommunicationInterface,
  OrderCommunicationExpiredInterface,
  OrderCommunicationExpiredByOfficeInterface,
  OrderCommunicationExpiredByOfficeRequestInterface,
} from '../../api/communication';

export interface CommunicationStore {
  orderCommunications: OrderCommunicationInterface[],
  orderId: string,
  error: any,

  currentOrderCommunication: OrderCommunicationInterface,

  orderCommunicationsExpired: OrderCommunicationExpiredInterface[]
  orderCommunicationsFiltetByPartnerId: string,
  orderCommunicationsFiltetByOfficeId: string,

  OrderCommunicationsExpiredByOffice: OrderCommunicationExpiredByOfficeInterface[];
  officeId: string,
}

export const communicationStore: CommunicationStore = observable({
  orderCommunications: [],
  orderId: null,
  error: null,

  currentOrderCommunication: null,

  orderCommunicationsExpired: [],
  orderCommunicationsFiltetByOfficeId: null,
  orderCommunicationsFiltetByPartnerId: null,

  OrderCommunicationsExpiredByOffice: [],
  officeId: null,
} as CommunicationStore);

export const communicationActions = {
  getOrderCommunications: async (orderId: string): Promise<void> => {
    communicationStore.orderId = orderId;
    const response = await communicationController.getOrderCommunications(orderId);
    communicationActions.handleError(response);
    runInAction(() => {
      const x = response.data?.items ?? [];
      // const x1 = sortBy(x, (item) => item?.nextDate);
      if (x.length > 0) { x.at(-1).isLast = true; }
      communicationStore.orderCommunications = x;
    });
  },

  createOrderCommunication: async (request: CreateOrderCommunicationInterface): Promise<void> => {
    const response = await communicationController.createOrderCommunication(request);
    communicationActions.handleError(response);
  },

  /*   editInvoiceDocument: async (id: string, request: EditOrderInvoiceDocumentsRequest): Promise<void> => {
    const response = await invoiceDocumentController.editOrderInvoiceDocuments(id, request);
    invoiceDocumentsActions.handleError(response);
    invoiceDocumentsActions.setCurrentInvoiceDocument(response.data);
  }, */

  deleteOrderCommunication: async (id: string): Promise<void> => {
    const response = await communicationController.deleteOrderCommunication(id);
    communicationActions.handleError(response);
  },

  clearOrderCommunications: action(() => {
    communicationStore.orderCommunications = [];
    communicationStore.orderId = null;
  }),

  clearCurrentCommunication: action(() => {
    communicationStore.currentOrderCommunication = null;
  }),

  clearError: action(() => {
    communicationStore.error = null;
  }),

  handleError: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      communicationStore.error = errorData;
      throw errorData;
    }
  }),

  setCurrentCommunication: action((communication: OrderCommunicationInterface) => {
     
    communicationStore.currentOrderCommunication = communication;
  }),

  getExpiredCommunications: async (): Promise<void> => {
    const response = await communicationController.getExpiredCommunications();
    communicationActions.handleError(response);
    runInAction(() => {
      communicationStore.orderCommunicationsExpired = response.data?.items ?? [];
    });
  },

  setOrderCommunicationsFiltetByOfficeId: action((partnerId: string, officeId: string)=> {
    communicationStore.orderCommunicationsFiltetByPartnerId = partnerId;
    communicationStore.orderCommunicationsFiltetByOfficeId = officeId;
  }),

  getExpiredCommunicationsByOffice: async (
    request: OrderCommunicationExpiredByOfficeRequestInterface
  ): Promise<void> => {
    communicationStore.officeId = request.officeId;

    const response = await communicationController.getExpiredCommunicationsByOffice(request);
    communicationActions.handleError(response);
    runInAction(() => {
      communicationStore.OrderCommunicationsExpiredByOffice = response.data?.items ?? [];
    });
  },

  clearExpiredCommunicationsByOffice: action(() => {
    communicationStore.OrderCommunicationsExpiredByOffice = [];
    communicationStore.officeId = null;
  }),

};
